import { render, staticRenderFns } from "./PersonalesConsultaBuro.vue?vue&type=template&id=3879c65a&lang=html&"
import script from "./PersonalesConsultaBuro.vue?vue&type=script&lang=js&"
export * from "./PersonalesConsultaBuro.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesConsultaBuro.vue?vue&type=style&index=0&id=3879c65a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports